module.exports = __webpack_public_path__ + "static/media/gaming3.7f0a2d04.webp";